import React, {useState, useContext, useEffect} from "react";
// design
import {Layout, Menu, Space, Dropdown} from "antd";
import {
    UserOutlined,
    DownOutlined,
} from "@ant-design/icons";
// route
import {BrowserRouter as Router, useHistory} from "react-router-dom";
// context
import {GlobalContext} from "../context/globalContext";
// method
import {getMethod} from '../services/methods';
// logo
import logo from '../assets/img/logo.png';

const {Header, Content, Sider} = Layout;

export default function Layout1({children}) {
    // context
    const {contextData, dispatch} = useContext(GlobalContext);

    // route
    let history = useHistory();

    useEffect(() => {
        const auth_check = async () => {
            const dashboardData = await getMethod("/auth");
            if (JSON.stringify(dashboardData).includes(401)) {
                localStorage.removeItem("token");
                localStorage.removeItem("globalContext");
                history.replace("/");
            }
        };
        auth_check();
        const interval = setInterval(() => {
            auth_check();
        }, 60000);
        return () => clearInterval(interval);
    }, []);

    return (
        <Layout className="layout-container">
            <Header className="header-main flex between">
                <Space className="flex middle">
                    <div className="logo">
                        {/*<img height={50} src={logo} />*/}
                    </div>
                </Space>

                <Dropdown
                    overlay={
                        <Menu>
                            <Menu.Item
                                key="Profil"
                                onClick={() => {
                                    history.push(`profile`)
                                }}
                            >
                                Profil
                            </Menu.Item>
                            <Menu.Item
                                key="Şifre Değiştir"
                                onClick={() => {
                                    history.push(`password`)
                                }}
                            >
                                Şifre Değiştir
                            </Menu.Item>
                            <Menu.Item
                                key="Çıkış Yap"
                                onClick={() => {
                                    localStorage.removeItem("token");
                                    localStorage.removeItem("globalContext");
                                    history.replace("/");
                                }}
                            >
                                Çıkış Yap
                            </Menu.Item>
                        </Menu>
                    }
                >
                    <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                        <UserOutlined style={{fontSize: "18px", color: "#fff"}}/>
                        <strong style={{
                            textTransform: "capitalize",
                            color: "white",
                            margin: "0 10px 0 5px"
                        }}>{contextData?.userData?.name} {contextData?.userData?.surname}</strong>
                        <DownOutlined style={{color: "#fff"}}/>
                    </a>
                </Dropdown>

            </Header>
            <Layout className="layout-wrapper">
                <Sider className="sider" className="site-layout-background">
                    <Menu
                        mode="inline"
                        selectedKeys={[history.location.pathname]}
                        style={{height: "100%", borderRight: 0}}
                    >
                        <Menu.Item
                            key="/"
                            onClick={() => {
                                history.push(`/`)
                            }}
                        >
                            Anasayfa
                        </Menu.Item>
                        <Menu.Item
                            key="/users"
                            onClick={() => {
                                history.push(`/users`)
                            }}
                        >
                            Kullanıcılar
                        </Menu.Item>
                        {
                            ["admin", "admin-center"].includes(contextData.userData.role) &&
                            <Menu.Item
                                key="/persons"
                                onClick={() => {
                                    history.push(`/persons`)
                                }}
                            >
                                Kişiler
                            </Menu.Item>
                        }
                        <Menu.Item
                            key="/reports"
                            onClick={() => {
                                history.push(`/reports`)
                            }}
                        >
                            Tamamlanma Raporu
                        </Menu.Item>
                        {
                            ["admin-state"].includes(contextData.userData.role) && <Menu.Item
                            key="/state-report"
                            onClick={() => {
                                history.push(`/state-report`)
                            }}
                        >
                            İlçe Raporu
                        </Menu.Item>}
                        {
                            ["admin"].includes(contextData.userData.role) &&
                            <Menu.Item
                                key="/photos"
                                onClick={() => {
                                    history.push(`/photos`)
                                }}
                            >
                                Fotoğraflar
                            </Menu.Item>
                        }
                    </Menu>
                </Sider>
                <Layout className="layout-main">
                    <Content className="site-layout-background">
                        {children}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
}
